
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hot/[id]",
      function () {
        return require("private-next-pages/hot/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hot/[id]"])
      });
    }
  